module.exports = __webpack_public_path__ + "static/img/point-left.0f0492a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/point-left.png
// module id = 6WTd
// module chunks = 0